export default __webpack_public_path__ + "static/media/food.7ee431c9.jpg";